import {
    AccessRight,
} from 'app/types/accessRights.types'
import contactAccessRights from 'app/access-rights/contactAccessRights'
import useHasPermissionType from './useHasPermissionType'

const useHasContactPermissionType = (
    categories: string[],
    type?: keyof AccessRight,
) => {
    return useHasPermissionType(categories, contactAccessRights, type)
}

export default useHasContactPermissionType
